module.exports = __webpack_public_path__ + "static/garlic-58c3a037439c83cf5e059a0efd63d008.svg";